import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import arrowLeft from "../assets/images/arrow-left.png";
import { getTeachersByProgram } from '../services/TeacherApi';
import LoadingSpinner from './LoadingSpinner';
import config from '../config/config';

const Teachers = () => {
  const { id: programId } = useParams();
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  // const location = useLocation();
  // const programId = location.state?.programId || null;

  useEffect(() => {
    fetchTeachers();
  }, []);

  const fetchTeachers = async () => {
    try {
      const response = await getTeachersByProgram(programId);
      setTeachers(response.data || []);
    } catch (error) {
      toast.error("Failed to fetch teacher data");
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => {
    if (programId) {
      navigate(`/course/${programId}`);
    } else {
      navigate(-1); // Fallback if no programId
    }
  };

  const goToTeacherDetails = (teacherId) => {
    navigate(`/teacherDetails/${teacherId}`, { state: { programId } });
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="app-container mobile-bottom">
      <Container>
        <div className="breadcrum bg_light_yellow mb-3">
          <h2 className="d-flex align-items-center mb-0 fs-20">
            <img src={arrowLeft} onClick={goBack} width={18} className="me-2" alt="back" />
            Teachers
          </h2>
        </div>
        <Row>
          {teachers.map((teacher, index) => (
            <Col key={teacher.id || index} xs="6" sm="4">
              <div className="text-center mb-3 teachers_main">
                <img
                  onClick={() => goToTeacherDetails(teacher.id)}
                  src={`${config.Image_Base_URL}${teacher.profile_pic_url}`}
                  className="me-2 border img-fluid border-dark rounded-3"
                  alt={teacher.name}
                />
                <h6 className="mb-0 mt-2 text-danger fs-12">{teacher.name}</h6>
                <small className="text-muted fs-9">
                  Course: <span className="fw-5 text-dark">{teacher.designation}</span>
                </small>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Teachers;
